import { render, staticRenderFns } from "./DisabledAction.vue?vue&type=template&id=98ecb786"
import script from "./DisabledAction.vue?vue&type=script&lang=js"
export * from "./DisabledAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports